import { TWITTER_EVENT_NAME_TO_ID } from "@faire/web-api--source/indigofair/settings/TWITTER_EVENT_NAME_TO_ID";
import { getSettingValueWithoutAssignment } from "./__internal__/getSetting";
export var getSettingTwitterEventNameToId = function() {
    return getSettingValueWithoutAssignment(TWITTER_EVENT_NAME_TO_ID, {});
};
